import { createSlice } from "@reduxjs/toolkit";

export const PAGE_FORM_KEY = "page-form"; // fallback key for forms rendered outside any modal

export const coreFormSlice = createSlice({
  name: "coreForm",
  initialState: {
    // keyed by form key (modal instance key or PAGE_FORM_KEY) so a reset/submit
    // in one modal never flashes the loader over forms in other modals/pages
    resettingByKey: {},
    isActionButtonsDisabled: false
  },
  reducers: {
    setIsResetting: (state, action) => {
      const { key = PAGE_FORM_KEY, value } = action.payload;
      state.resettingByKey[key] = !!value;
    },
    setIsActionButtonsDisabled: (state, action) => {
      state.isActionButtonsDisabled = action.payload;
    },
  }
});

export const { setIsResetting, setIsActionButtonsDisabled } = coreFormSlice.actions;
export default coreFormSlice.reducer;
